module.exports = __webpack_public_path__ + "img/logo.aec2793d.png";